/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, Enum, EnumSet } from '@gh/core-data';
import { ContactDetailsCommunicationDataDto } from './contact-details-communication.dto';
import {
  ContactDetailsCustomFieldListDto,
  ContactDetailsPaymentPayeeDto,
  ContactDetailsTermsPayeeDto,
} from './contact-details-shared.dto';
import { globalDictionaries } from '@gh/common-shared';

export const EmployeePayroll = createEnum(globalDictionaries.employeePayroll, {
  Weekly: 'WEEKLY',
  Fortnightly: 'FORTNIGHTLY',
  FourWeekly: 'FOUR_WEEKLY',
  Monthly: 'MONTHLY',
});

export type EmployeePayroll = EnumSet<typeof EmployeePayroll>;

export const EmployeePayBasis = createEnum(globalDictionaries.payBasis, {
  Hourly: 'HOURLY',
  Salary: 'SALARY',
});

export type EmployeePayBasis = EnumSet<typeof EmployeePayBasis>;

export type ContactDetailsEmployeePersonalDto = {
  nameToPrintOnChecks?: string;
  taxFileNumber?: string;
  gender?: Enum<any>;
  dateOfBirth?: Date;
  startDate?: Date;
  terminationDate?: Date;
};

export type ContactDetailsEmployeeSalaryDto = {
  payrollCycle?: EnumSet<any>;
  hoursInPayPeriod?: number;
  payBasis?: EnumSet<any>;
  salary?: number;
  hourlyRate?: number | null;
  commissionRate?: number;
};

export type ContactDetailsEmployeeCommonDto = {
  personal: ContactDetailsEmployeePersonalDto;
  salary: ContactDetailsEmployeeSalaryDto;
};

export type ContactDetailsEmployeeDto = {
  common: ContactDetailsEmployeeCommonDto;
  payment: ContactDetailsPaymentPayeeDto;
  terms: ContactDetailsTermsPayeeDto;
  communication: ContactDetailsCommunicationDataDto;
  customFields: ContactDetailsCustomFieldListDto;
};
